<div
	class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs {{ sectionclass }}"
	[ngClass]="{ 'c-portlet-2': isPreroll || isGeovideo || isCTV || isVideo || isRadio || isGam }"
>
	<app-loader [showLoader]="showLoad"></app-loader>
	<div>
		<div class="creativeHeader">{{ sectiontitle | uppercase }}</div>
		<a
			href="#"
			class="datatable_download_icon"
			*ngIf="hasData && downloadConfiguration && downloadConfiguration.enableDownload"
			(click)="downloadCSV()"
			target="_blank"
		>
			<img class="downloadIcon" src="../../../../../assets/creative-assets/download.svg" />
		</a>
	</div>
	<div *ngIf="hasData">
		<ngu-carousel
			#carousel
			[inputs]="carouselOne"
			(carouselLoad)="initDataFn($event)"
			[dataSource]="creatives"
			(onMove)="onmoveFn($event)"
		>
			<ngu-tile NguCarouselItem *nguCarouselDef="let creative; let i = index">
				<div class="stats-container">
					<div class="outer-div" [ngClass]="{ 'outer-div-2': isPreroll || isGeovideo || isVideo || isGam }">
						<div class="upper-div">
							<div *ngIf="isR104" class="textLeft creative_name">
								<p [title]="creative?.creativeName">{{ creative?.creativeName }}</p>
								<div class="test">{{ i + 1 }} / {{ creatives.length }}</div>
							</div>
							<div
								class="left-stats inline"
								[ngClass]="{ 'r6-sem-creative': !isCutoffDate }"
								[ngClass]="{ 'pt-8p': isGeofence || isCTV }"
								[ngClass]="{ 'outer-div-3': isRadio }"
							>
								<div class="textLeft creative_name">
									<p [title]="creative?.creativeName">{{ creative?.creativeName }}</p>
								</div>

								<div class="p-20" [ngClass]="{ radioImp: isRadio }">
									<div class="textLeft">
										<span *ngIf="!isR104" class="stats-label">IMPRESSIONS</span>
										<span *ngIf="isR104" class="stats-label impressions">Impressions</span>
										<div class="stats" [ngClass]="{ statsImp: isRadio }">{{ creative?.impressions | number }}</div>
									</div>
								</div>
								<div class="display-stats-border p-20" *ngIf="!isCTV && !isRadio">
									<div class="inline textLeft">
										<span class="stats-label">CLICKS</span>
										<div class="stats">{{ creative?.clicks | number }}</div>
									</div>
									<div class="inline textLeft pl-19p">
										<span class="stats-label">CLICK RATE</span>
										<div class="stats">{{ creative?.clickRate | number : '0.2-2' }}%</div>
									</div>
									<div style="clear: both"></div>
								</div>
								<div class="display-stats-border p-20" *ngIf="(isPreroll || isGam) && youtubeViewsPermission">
									<div class="inline textLeft">
										<span class="stats-label">YOUTUBE VIEWS</span>
										<div class="stats">{{ creative?.youtubeviews | number }}</div>
									</div>
									<div class="inline textLeft pl-19p">
										<span class="stats-label">YOUTUBE VIEW RATE</span>
										<div class="stats">{{ creative?.youtubeviewsrate | number : '0.2-2' }}%</div>
									</div>
									<div style="clear: both"></div>
								</div>
								<div
									class="display-stats-border p-20"
									[ngClass]="{ radioComp: isRadio }"
									*ngIf="isPreroll || isGeovideo || isCTV || creative?.isVideoCreative || isRadio"
								>
									<div class="inline textLeft">
										<span class="stats-label">COMPLETIONS</span>
										<div class="stats" [ngClass]="{ statsImp: isRadio }">{{ creative?.completions | number }}</div>
									</div>
									<div class="inline textLeft pl-19p">
										<span class="stats-label">COMPLETION RATE</span>
										<div class="stats" [ngClass]="{ statsImp: isRadio }">
											{{ creative?.completionRate | number : '0.2-2' }}%
										</div>
									</div>
									<div style="clear: both"></div>
								</div>
								<div class="display-stats-border p-20" *ngIf="isDisplay || (isGam && !creative?.isVideoCreative)">
									<div class="inline textLeft">
										<span class="stats-label">AD INTERACTIONS</span>
										<div class="stats">{{ creative?.adInteractions | number }}</div>
									</div>
									<div class="inline textLeft pl-19p">
										<span class="stats-label">AD INTERACTION RATE</span>
										<div class="stats">{{ creative?.adInteractionRate | number : '0.2-2' }}%</div>
									</div>
									<div style="clear: both"></div>
								</div>
								<div class="display-stats-border p-20" *ngIf="isSem && !isCutoffDate">
									<div class="textLeft">
										<span class="stats-label">AVG. POSITION</span>
										<div class="stats">
											{{ creative.avgPosition ? (creative.avgPosition | number : '0.2-2') : '--' }}
										</div>
									</div>
								</div>
								<div class="display-stats-border p-20 r6-sem-creative-margin" *ngIf="isSem">
									<div class="inline textLeft" *ngIf="!isGoliveNotStarted">
										<span class="stats-label">ABS. TOP IMPRESSION</span>
										<div class="stats">{{ creative?.absTopImpression | number : '0.2-2' }}%</div>
									</div>
									<div class="inline textLeft pl-19p" *ngIf="!isGoliveNotStarted">
										<span class="stats-label">TOP IMPRESSION</span>
										<div class="stats">{{ creative?.topImpression | number : '0.2-2' }}%</div>
									</div>
									<div style="clear: both"></div>
								</div>
								<div
									class="display-stats-border p-20"
									*ngIf="isSocial"
									[ngClass]="{ socialStaticCeative: !creative?.isVideoCreative }"
								>
									<div class="textLeft">
										<span class="stats-label">ENGAGEMENTS</span>
										<div class="stats">
											{{ creative?.engagements | number }}
											<i
												class="fa engagements-dropdown-icon"
												aria-hidden="true"
												(click)="showEngagemetsStats = !showEngagemetsStats"
												[ngClass]="showEngagemetsStats ? 'fa-angle-down' : 'fa-angle-right'"
											></i>
										</div>
										<div
											class="engagements-stats"
											[ngClass]="showEngagemetsStats ? 'show-engagements' : 'hide-engagements'"
										>
											<div class="each-eng-stat">
												<div class="eng-stat-name">LIKES</div>
												<div class="eng-stat-value">{{ creative?.likes | number }}</div>
											</div>
											<div class="each-eng-stat">
												<div class="eng-stat-name">COMMENTS</div>
												<div class="eng-stat-value">{{ creative?.comments | number }}</div>
											</div>
											<div class="each-eng-stat">
												<div class="eng-stat-name">SHARES</div>
												<div class="eng-stat-value">{{ creative?.shares | number }}</div>
											</div>
											<div class="each-eng-stat">
												<div class="eng-stat-name">SAVES</div>
												<div class="eng-stat-value">{{ creative?.saves | number }}</div>
											</div>
											<div class="each-eng-stat">
												<div class="eng-stat-name">REACTIONS</div>
												<div class="eng-stat-value">{{ creative?.reactions | number }}</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="creative-video inline" *ngIf="!isRadio">
								<div *ngIf="creative?.isVideoCreative && !isSem && !isSocial" class="card-long-img">
									<div class="align-controls">
										<div class="ShowControls">
											<video
												[ngClass]="{
													preroll_placeholder_img: (isPreroll || isGam) && creative?.creativeVideo === null
												}"
												class="prerollVideo"
												id="preRollvideo{{ i }}"
												autoplay
												[muted]="'muted'"
												#videoName
												[src]="creative?.creativeVideo"
											>
												<source type="video/mp4" />
												Your browser does not support HTML5 video.
											</video>
											<div class="playControls">
												<span class="playVideo" id="playBtn{{ i }}" (click)="playclickEvent(i)">
													<img class="volumeClass" src="./assets/images/r6-play-button.png" />
												</span>
												<span id="pauseBtn{{ i }}" class="playVideo" (click)="pauseclickEvent(i)">
													<img class="volumeClass" src="./assets/images/pause.png" />
												</span>
											</div>
											<div class="volumecontrols">
												<div class="volumeCtrl">
													<span id="volumeBtn{{ i }}" class="volumeControlIcon" (click)="muteclick(i)">
														<!-- <span class="VolumeControlHoverClass">&nbsp;&nbsp;&nbsp;MUTE&nbsp;&nbsp;&nbsp;</span> -->
														<img class="volumeClass" src="./assets/images/muteicon.png" />
													</span>
													<span id="muteBtn{{ i }}" class="volumeControlIcon" (click)="volumeclick(i)">
														<!-- <span class="VolumeControlHoverClass">UNMUTE</span> -->
														<img class="volumeClass" src="./assets/images/unmuteicon.png" />
													</span>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="creative-thumbnail" *ngIf="!creative?.isVideoCreative && !isSem && !isSocial">
									<div
										class="card-long-img"
										(click)="openModal('custom-modal-creative-preview', creative)"
										[ngStyle]="{
											background:
												!creative?.creativeThumbnail || creative?.creativeThumbnail === 'null'
													? 'url(' + placeholderimage + ') no-repeat center center'
													: 'url(' + creative?.creativeThumbnail + ') no-repeat center center',
											'background-size': getCreativeSize(creative.creativeThumbnail)
										}"
									></div>
								</div>
								<div class="sem-creative-card" *ngIf="isSem">
									<div class="sem-creative-heading">{{ creative.adHeadline }}</div>
									<div class="sem-creative-card-link-container">
										<span class="sem-creative-card-text">AD</span>
										<cite class="sem-creative-card-link">{{ creative.url }}</cite>
									</div>
									<span class="sem-creative-card-roboto"> {{ creative.callExtension }}</span>
									<div class="sem-creative-card-description sem-creative-card-roboto">
										{{ creative.description }}
									</div>
									<div class="sem-creative-card-callouts-container sem-creative-card-roboto">
										<div>
											<p>
												<span
													class="sem-creative-card-roboto"
													*ngFor="let callout of creative?.calloutsExtn; let i = index"
													>{{ callout
													}}<span [ngClass]="{ last_callout_class: i == creative?.calloutsExtn.length - 1 }">
														&middot;
													</span></span
												>
											</p>
										</div>
									</div>
									<div class="sem-creative-card-structuredsnippets-container sem-creative-card-roboto">
										<div *ngFor="let snippet of creative?.structuredSnippetExtn">
											<p class="sem-creative-card-roboto">{{ snippet?.type }}: {{ snippet?.value }}</p>
										</div>
									</div>
									<div class="sem-creative-card-siteLinks-container">
										<div *ngFor="let siteLink of creative.siteLinks" class="sem-creative-card-sitelinks">
											<h4>
												<a href="{{ siteLink.link }}" target="_blank">{{ siteLink.heading }}</a>
											</h4>
											<span class="sem-creative-card-roboto">{{ siteLink.description }}</span>
										</div>
									</div>
									<div>
										<span class="sem-creative-card-location" *ngIf="creative.location"
											><i class="fa fa-map-marker" aria-hidden="true" style="color: #575757"></i>
											{{ creative.location }}</span
										>
									</div>
								</div>
								<div
									*ngIf="isSocial && creative.isIframeExpired === true && creative?.hasSnapshotImage"
									class="social-media card-long-img"
								>
									<div
										*ngIf="creative?.snapshotImage"
										class="card-long-img"
										(click)="openModal('custom-modal-creative-preview', creative)"
										[ngStyle]="{
											background: 'url(' + creative?.snapshotImage + ') no-repeat center center',
											'background-size': getCreativeSize(creative.snapshotImage)
										}"
									></div>
									<div style="clear: both"></div>
								</div>
								<div
									*ngIf="isSocial && creative.isIframeExpired === false && creative?.iframeUrl !== null"
									class="social-media card-long-img"
								>
									<div
										*ngIf="creative?.iframeUrl !== null"
										class="card-long-img"
										(click)="openModal('custom-modal-creative-preview', creative)"
										[ngStyle]="{
											background: 'url(' + creative?.creativeThumbnail + ') no-repeat center center',
											'background-size': getCreativeSize(creative.creativeThumbnail)
										}"
									></div>
									<div style="clear: both"></div>
								</div>
								<div
									*ngIf="
										(isSocial && creative.isIframeExpired === true && !creative?.hasSnapshotImage) ||
										(creative.isIframeExpired === false && creative.iframeUrl === null)
									"
									class="social-media card-long-img"
								>
									<div
										*ngIf="creative?.creativeThumbnail"
										class="card-long-img"
										[ngStyle]="{
											background:
												'url(../../../../../../assets/images/R6-empty-creative-preview.svg) no-repeat center center',
											'background-size': getCreativeSize(creative.creativeThumbnail)
										}"
									></div>
									<div style="clear: both"></div>
								</div>
								<div style="clear: both"></div>
							</div>
							<div class="creative-video inline" *ngIf="isRadio">
								<div class="audio-container card-long-img">
									<div class="icon-block" *ngIf="creative?.audioURL !== undefined; else noAudioCreative">
										<svg xmlns="http://www.w3.org/2000/svg" width="128" height="105" viewBox="0 0 128 105">
											<path
												class="primary-svg-fill"
												d="M16 59.59c.552 0 1 .449 1 1v42.82c0 .551-.448 1-1 1H4c-2.21 0-4-1.792-4-4V63.59c0-2.208 1.79-4 4-4h12zm108 0c2.21 0 4 1.792 4 4v36.82c0 2.208-1.79 4-4 4h-12c-.552 0-1-.449-1-1V60.59c0-.551.448-1 1-1h12zM62.52 62.2c.31.363.48.824.48 1.3v36.32c0 1.105-.895 2-2 2-.476 0-.937-.17-1.3-.48l-11.184-9.558c-.362-.31-.823-.48-1.299-.48H44c-1.105 0-2-.895-2-2V74.018c0-1.104.895-2 2-2h3.217c.476 0 .937-.17 1.3-.48L59.7 61.98c.84-.718 2.102-.619 2.82.22zm17.853 5.719C83.95 71.539 86 76.439 86 81.66c0 5.222-2.049 10.122-5.627 13.741-1 1.012-2.622 1.012-3.623 0-1-1.012-1-2.652 0-3.664 2.627-2.657 4.127-6.244 4.127-10.077s-1.5-7.42-4.127-10.077c-1-1.012-1-2.652 0-3.664s2.623-1.012 3.623 0zm-7.148 6.973C74.989 76.674 76 79.09 76 81.66c0 2.57-1.011 4.986-2.775 6.768-.967.976-2.534.976-3.5 0-.934-.944-.966-2.455-.094-3.436l.094-.1c.845-.853 1.325-2 1.325-3.232 0-1.166-.431-2.258-1.195-3.095l-.13-.137c-.967-.977-.967-2.56 0-3.536.966-.976 2.533-.976 3.5 0zM64 0c32.532 0 58.967 26.109 59.492 58.516l.008.984h-9C114.5 31.61 91.89 9 64 9 36.389 9 13.953 31.16 13.507 58.665l-.007.835h-9C4.5 26.64 31.14 0 64 0z"
											/>
										</svg>
									</div>
									<ng-template #noAudioCreative>
										<div class="icon-block no-audio-creative">NO DATA AVAILABLE</div>
									</ng-template>
									<div class="audio-file-block">
										<audio
											class="audioCreative"
											[src]="creative?.audioURL"
											[controls]="'controls'"
											[controlsList]="'nodownload'"
										></audio>
									</div>
								</div>
								<div style="clear: both"></div>
							</div>
							<div style="clear: both"></div>
						</div>
						<div
							class="bottom-div display-stats-border flexDiv"
							[ngClass]="{ bottomRadio: isRadio }"
							*ngIf="isPreroll || isGeovideo || isCTV || creative?.isVideoCreative || isRadio"
						>
							<div
								class="inline-div textLeft compRate"
								appTooltip
								title="Tooltip"
								[title]="formatValuesForComma(creative.videoCompletionPercentage?.quarterValue) + ' Views'"
								data-size="small"
								[options]="tooltipOptions"
							>
								<span class="stats-label">25% COMPLETE</span>
								<div class="stats" [ngClass]="{ statsImp: isRadio }">
									{{ creative.videoCompletionPercentage?.quarter }}%
								</div>
							</div>
							<div class="inline-div textLeft spaceDiv"></div>
							<div
								class="inline-div compRate"
								appTooltip
								title="Tooltip"
								[title]="formatValuesForComma(creative.videoCompletionPercentage?.halfValue) + ' Views'"
								data-size="small"
								[options]="tooltipOptions"
							>
								<span class="stats-label">50% COMPLETE</span>
								<div class="stats" [ngClass]="{ statsImp: isRadio }">
									{{ creative.videoCompletionPercentage?.half }}%
								</div>
							</div>
							<div class="inline-div textLeft spaceDiv"></div>
							<div
								class="inline-div compRate"
								appTooltip
								title="Tooltip"
								[title]="formatValuesForComma(creative.videoCompletionPercentage?.threeQuartersValue) + ' Views'"
								data-size="small"
								[options]="tooltipOptions"
							>
								<span class="stats-label">75% COMPLETE</span>
								<div class="stats" [ngClass]="{ statsImp: isRadio }">
									{{ creative.videoCompletionPercentage?.threeQuarters }}%
								</div>
							</div>
							<div class="inline-div textLeft spaceDiv"></div>
							<div
								class="inline-div textRight compRate"
								appTooltip
								title="Tooltip"
								[title]="formatValuesForComma(creative.videoCompletionPercentage?.completionValue) + ' Views'"
								data-size="small"
								[options]="tooltipOptions"
							>
								<span class="stats-label">100% COMPLETE</span>
								<div class="stats" [ngClass]="{ statsImp: isRadio }">
									{{ creative.videoCompletionPercentage?.completed }}%
								</div>
							</div>
							<div style="clear: both"></div>
						</div>
					</div>
				</div>
			</ngu-tile>
			<ul class="myPoint" NguCarouselPoint>
				<li
					*ngFor="let j of carousel.pointNumbers; let k = index"
					[class.primary-color-bg]="j == carousel.activePoint"
					(click)="moveToNext(k)"
					[style.background]="'url(' + creatives[j] + ')'"
				></li>
			</ul>
		</ngu-carousel>
		<div *ngIf="isCreativeArrow" class="navigation_arrows">
			<div class="left_arrow">
				<a href="javascript:void(null)">
					<img *ngIf="!isR104" (click)="nextArrow()" src="../../../../../assets/images/chevron-left-large.png" />
					<img *ngIf="isR104" (click)="nextArrow()" src="../../../../../assets/creative-assets/arrow-left-r104.svg" />
				</a>
			</div>
			<div class="right_arrow">
				<a href="javascript:void(null)">
					<img *ngIf="!isR104" (click)="prevArrow()" src="../../../../../assets/images/chevron-right-large.svg" />
					<img *ngIf="isR104" (click)="prevArrow()" src="../../../../../assets/creative-assets/arrow-right-r104.svg" />
				</a>
			</div>
		</div>
	</div>
	<div *ngIf="!hasData" class="no-data-creative">
		<div class="no-data-text">No Data Available</div>
	</div>
	<app-modal id="custom-modal-creative-preview" *ngIf="selectedCreative">
		<div class="modal">
			<div class="modal-body">
				<div class="modal-header">
					<div class="creative-name">
						{{ selectedCreative?.creativeName }}
						<div class="close-button" (click)="closeModal('custom-modal-' + selectedCreative?.versionId)">
							<img src="../../../../../assets/images/cancel.svg" />
						</div>
					</div>
				</div>
				<div class="modal-content">
					<app-creative-ad-preview
						[creative]="selectedCreative"
						(modalClose)="closeModal('custom-modal-creative-preview')"
						*ngIf="
							selectedCreative?.hasAdSizes || selectedCreative?.isNative || selectedCreative?.iframeUrl;
							else noAdSizePreviewBlock
						"
					>
					</app-creative-ad-preview>
					<ng-template #noAdSizePreviewBlock>
						<div style="font-size: 1.6em; padding: 30px 20px">No different adsizes available for preview.</div>
					</ng-template>
				</div>
			</div>
		</div>
		<div class="modal-background"></div>
	</app-modal>
</div>
